;(function () {
	'use strict';

	if (!customElements.get('featured-blog')) {
		class FeaturedBlog extends HTMLElement {
			constructor() {
				super();
				this.viewport     = null;
				this.track        = null;
				this.slides       = [];
				this.pagination   = null;
				this.nextBtn      = null;
				this.prevBtn      = null;
				this.currentIndex = 0;
				this.perView      = 1;
				this.spaceBetween = 0;
				this._active      = false;
			}

			connectedCallback() {
				const { enableSliderDesktop, enableSliderMobile } = this.dataset;
				if (enableSliderDesktop !== 'true' && enableSliderMobile !== 'true') return;

				this.viewport   = this.querySelector('.ab-fb-viewport');
				this.track      = this.querySelector('.ab-fb-track');
				this.slides     = Array.from(this.querySelectorAll('.ab-fb-slide'));
				this.pagination = this.querySelector('.ab-fb-pagination');
				this.nextBtn    = this.querySelector('.blog-button-next');
				this.prevBtn    = this.querySelector('.blog-button-prev');

				if (!this.track || this.slides.length === 0) return;

				this.init();
				window.addEventListener('resize', () => this.init());
				this.track.addEventListener('scroll', () => this._onScroll(), { passive: true });

				if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());
				if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
			}
		}

		FeaturedBlog.prototype._shouldBeActive = function () {
			const w = window.innerWidth;
			const { enableSliderDesktop, enableSliderMobile } = this.dataset;
			if (enableSliderDesktop === 'true' && enableSliderMobile === 'true') return true;
			if (enableSliderMobile === 'true' && enableSliderDesktop === 'false' && w < 1200) return true;
			if (enableSliderDesktop === 'true' && enableSliderMobile === 'false' && w >= 1200) return true;
			return false;
		};

		FeaturedBlog.prototype._getConfig = function () {
			const w = window.innerWidth;
			const { gap, gapMobile, slidesPerView, slidesPerViewDesktop } = this.dataset;
			let spaceBetween = 0, spaceBetweenMb = 0;

			if (gap === 'offset-col-lg-3') spaceBetween = 30;
			else if (gap === 'offset-col-lg-2') spaceBetween = 20;
			if (gapMobile === 'offset-col-sm-2') spaceBetweenMb = 20;

			if (w >= 1025) return { perView: parseFloat(slidesPerViewDesktop) || 3, spaceBetween };
			if (w >= 750)  return { perView: parseFloat(slidesPerView) || 1, spaceBetween };
			return { perView: parseFloat(slidesPerView) || 1, spaceBetween: spaceBetweenMb };
		};

		FeaturedBlog.prototype.init = function () {
			if (this._shouldBeActive()) {
				if (!this._active) {
					this._active = true;
					if (this.viewport) this.viewport.classList.add('ab-fb-active');
					this._buildPagination();
				}
				this._setSlideWidths();
				this._restorePosition();
				this._updateNavState();
				this._updateDots();
			} else {
				if (this._active) {
					this._active = false;
					if (this.viewport) this.viewport.classList.remove('ab-fb-active');
					this.currentIndex = 0;
					this.track.scrollTo({ left: 0, behavior: 'instant' });
					this._destroyPagination();
					this.slides.forEach(s => { s.style.width = ''; s.style.marginRight = ''; });
				}
			}
		};

		FeaturedBlog.prototype._setSlideWidths = function () {
			const { perView, spaceBetween } = this._getConfig();
			this.perView      = perView;
			this.spaceBetween = spaceBetween;
			const slideWidth  = (this.track.clientWidth - spaceBetween * (perView - 1)) / perView;
			this.slides.forEach((slide, i) => {
				slide.style.width       = slideWidth + 'px';
				slide.style.marginRight = i < this.slides.length - 1 ? spaceBetween + 'px' : '0';
			});
		};

		FeaturedBlog.prototype._restorePosition = function () {
			const target = this.slides[this.currentIndex];
			if (target) this.track.scrollTo({ left: target.offsetLeft, behavior: 'instant' });
		};

		FeaturedBlog.prototype.next = function () { this._goTo(this.currentIndex + 1); };
		FeaturedBlog.prototype.prev = function () { this._goTo(this.currentIndex - 1); };

		FeaturedBlog.prototype._goTo = function (index) {
			const maxIndex = Math.max(0, this.slides.length - Math.floor(this.perView));
			index = Math.max(0, Math.min(index, maxIndex));
			this.currentIndex = index;
			const target = this.slides[index];
			if (target) this.track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
			this._updateNavState();
			this._updateDots();
		};

		FeaturedBlog.prototype._onScroll = function () {
			if (!this._active) return;
			const scrollLeft = this.track.scrollLeft;
			let closest = 0, minDiff = Infinity;
			this.slides.forEach((slide, i) => {
				const diff = Math.abs(slide.offsetLeft - scrollLeft);
				if (diff < minDiff) { minDiff = diff; closest = i; }
			});
			if (closest !== this.currentIndex) {
				this.currentIndex = closest;
				this._updateNavState();
				this._updateDots();
			}
		};

		FeaturedBlog.prototype._updateNavState = function () {
			const maxIndex = Math.max(0, this.slides.length - Math.floor(this.perView));
			const atStart  = this.currentIndex <= 0;
			const atEnd    = this.currentIndex >= maxIndex;
			if (this.prevBtn) this.prevBtn.setAttribute('aria-disabled', String(atStart));
			if (this.nextBtn) this.nextBtn.setAttribute('aria-disabled', String(atEnd));
		};

		FeaturedBlog.prototype._buildPagination = function () {
			if (!this.pagination) return;
			this.pagination.innerHTML = '';
			this.slides.forEach((_, i) => {
				const dot = document.createElement('button');
				dot.className = 'ab-fb-dot' + (i === 0 ? ' active' : '');
				dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
				dot.addEventListener('click', () => this._goTo(i));
				this.pagination.appendChild(dot);
			});
		};

		FeaturedBlog.prototype._destroyPagination = function () {
			if (this.pagination) this.pagination.innerHTML = '';
		};

		FeaturedBlog.prototype._updateDots = function () {
			if (!this.pagination) return;
			this.pagination.querySelectorAll('.ab-fb-dot').forEach((dot, i) => {
				dot.classList.toggle('active', i === this.currentIndex);
			});
		};

		customElements.define('featured-blog', FeaturedBlog);
	}
})();
